// 酒精销售许可证
import { i18n } from '@/common/utils/i18n'
import { get, isEmpty } from 'lodash-es'

export default (state) => {
  let wine = get(state, 'currentShopBaseDetail.docInfo.wine', {})
  const objIsEmpty = isEmpty(wine)
  return {
    title: i18n.gettext('酒精销售许可证'),
    content: [
      {
        title: i18n.gettext('资质类型'),
        // licenseKind :资质类型 2：饮料店期间限定酒品贩卖准证  1：一般酒精产品贩卖准证(长期有效)
        label: objIsEmpty ? i18n.gettext('暂无') : +get(wine, 'licenseKind', '') === 2 ? i18n.gettext('饮料店期间限定酒品贩卖准证') : i18n.gettext('一般酒精产品贩卖准证')
      },
      {
        title: i18n.gettext('有效期'),
        label: objIsEmpty ? i18n.gettext('暂无') : +get(wine, 'licenseKind', '') === 1 ? i18n.gettext('长期有效') : wine.validateDate
      },
      {
        title: i18n.gettext('执照照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: get(wine, 'licensePics', {})
      }
    ]
  }
}
